import styled from "styled-components";
import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles<Theme>((theme) => ({
	inputAutoComplete: {
		"& .MuiSvgIcon-root": {
			color: theme.palette.primary.main,
		},
		"& .MuiFormHelperText-root": {
			background: "none !important",
		},
		"& .MuiFormHelperText-root.Mui-disabled": {
			color: theme.palette.error.main,
		},
		"& .MuiAutocomplete-popupIndicator:not(.Mui-disabled)": {
			zIndex: 1,

			"& .MuiSvgIcon-root": {
				background: "white",
			},
		},
		"& .Mui-disabled": {
			backgroundColor: theme.palette.primary.light,
		},
	},
}));

export const Spinner = styled.div`
	border: 3px solid rgba(0, 0, 0, 0.1);
	border-left-color: ${({ theme }) => theme.pantone2726C};
	border-radius: 50%;
	width: 20px;
	height: 20px;
	animation: spin 1s linear infinite;
	margin: 0 10px;

	@keyframes spin {
		to {
			transform: rotate(360deg);
		}
	}
`;
